import CryptoJS from 'crypto-js'
/* eslint-disable */
/**
 * @description aes加密
 * @param {string} word 需要加密的字符串
 */

export function cryptoEncrypt (word, aes_key) {
  const key = CryptoJS.enc.Utf8.parse(aes_key)
  const srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = '';

  encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
}

/**
 * @description aes解密
 * @param {string} word 需要解密的字符串
 */

export function cryptoDecrypt(word, aes_key) {
  const key = CryptoJS.enc.Utf8.parse(aes_key)
  const encryptedHexStr = CryptoJS.enc.Base64.parse(word)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = ''

  decrypt = CryptoJS.AES.decrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypt.toString(CryptoJS.enc.Utf8).toString()
}


// WEBPACK FOOTER //
// ./src/axios/aes.js